import { APICore } from "./apiCore";

const api = new APICore()

function getUsuarios(params: any): any {
    const baseUrl = "/usuarios"
    return api.get(baseUrl, params)
}

function getUsuario(id: String): any {
    const baseUrl = `/usuarios/${id}`
    return api.get(baseUrl, {})
}

function addUsuario(params: any): any {
    const baseUrl = "/usuarios"
    return api.createWithFile(baseUrl, params)
}
function updateUsuario(params: any): any {
    const baseUrl = "/usuarios"
    return api.updateWithFile(baseUrl, params)
}
function updateUsuarioSelf(params: any): any {
    const baseUrl = "/usuarios/self"
    return api.updateWithFile(baseUrl, params)
}

function deleteUsuario(params: any): any {
    const baseUrl = "/usuarios"
    return api.delete(baseUrl, params)
}

export { getUsuarios, getUsuario, addUsuario, updateUsuario, updateUsuarioSelf, deleteUsuario }